import { useConversationDetail } from "./useConversationDetail";

/**
 * Read whether the current conversation is team-visible (`is_team_visible`,
 * surfaced by VS3/VS4) off the same ConversationDetail query that
 * `useAccessMode`, `useConversationAgent`, and `useConversationClient` already
 * warm, so the chat-header "Team" badge and the share popover's team toggle
 * read the flag with no extra network round-trip.
 *
 * Pending and error states fail closed to `false` (no badge, toggle off) — the
 * same posture as the sibling hooks; no optimistic render until the value is
 * actually known.
 */
export function useConversationTeamVisible(
    remoteId: number | string | undefined
): boolean {
    return useConversationDetail(remoteId).data?.is_team_visible ?? false;
}
